// extracted by mini-css-extract-plugin
export default {"cls1":"g68FifUw2DlAuDwLWPPb","cls2":"Wgywoy1vQoiDCbqMaoLO g68FifUw2DlAuDwLWPPb"};